import {Map, List} from 'immutable';

export default class queryHelper {

  static objectifyUri(search) {
    let q = {
      filters: {}
    };
    let query = queryHelper.getURLParameter(search, 'query');
    if (query) {
      q.query = query;
    }
    let page = queryHelper.getURLParameter(search, 'page');
    if (page) {
      q.offset = (page - 1) * 10;
      q.limit = 10;
    }
    let articleLabel = queryHelper.getURLParameter(search, 'articlelabel');
    if (articleLabel) {
      q.filters.articleLabel = articleLabel;
    }
    let language = queryHelper.getURLParameter(search, 'language');
    if (language) {
      q.filters.language = language.split(',');
    }
    let publication = queryHelper.getURLParameter(search, 'publication');
    if (publication) {
      q.filters.publication = publication.split(',');
    }
    let type = queryHelper.getURLParameter(search, 'type');
    if (type) {
      q.filters.type = type.split(',');
    }
    let tags = queryHelper.getURLParameter(search, 'tags');
    if (tags) {
      q.filters.tags = tags.split(',,');
    }
    let date = queryHelper.getURLParameter(search, 'date');
    if (language) {
      q.filters.date = date;
    }
    return q;
  }

  static getURLQuery(q) {
    let params = {};
    if (q.query) {
      params.query = q.query;
    }
    if (q.offset) {
      params.offset = q.offset;
    }
    if (q.limit) {
      params.limit = q.limit;
    }

    if (q.filters) {
      if (q.filters.tags && q.filters.tags.length > 0) {
        params['filter[tags]'] = q.filters.tags;
      }
      if (q.filters.type && q.filters.type.length > 0) {
        let filteredTypes = [].concat(q.filters.type);
        let types = [];
        let topTypes = ['article', 'structure', 'annotation'];
        topTypes.forEach(type => {
          let index = filteredTypes.indexOf(type);
          if (index >= 0) {
            types.push(type);
            filteredTypes.splice(index, 1);
          }
        });
        if (types.length > 0) {
          params['filter[type]'] = types;
        }
        if (filteredTypes.length > 0) {
          params['filter[anno_type]'] = filteredTypes;
        }
      }
      if (q.filters.articleLabel) {
        let label = q.filters.articleLabel;
        let artNumber = label.match(/\d+/);
        if (artNumber) {
          params['filter[article_label]'] = 'art ' + artNumber[0];
        }
      }
      if (q.filters.publication && q.filters.publication.length > 0) {
        params['filter[canonical]'] = q.filters.publication;
      }
      if (q.filters.language && q.filters.language.length > 0) {
        params['filter[language]'] = q.filters.language;
      }
      if (q.filters.date) {
        params['filter[date]'] = q.filters.date;
      }
    }
    return params;
  }

  static getURLParameter(search, name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
  }

  static validQuery(query) {
    if (query.query) {
      return true;
    }
    if (query.filters.articleLabel) {
      return true;
    }
    if (query.filters.language && query.filters.language.length > 0) {
      return true;
    }
    if (query.filters.publication && query.filters.publication.length > 0) {
      return true;
    }
    if (query.filters.type && query.filters.type.length > 0) {
      return true;
    }
    if (query.filters.date) {
      return true;
    }
    if (query.filters.tags && query.filters.tags.length > 0) {
      return true;
    }
    return false;
  }

  static queryToUri(q) {
    let elements = [];
    if (q.query) {
      elements.push('query=' + encodeURIComponent(q.query));
    }
    if (q.filters) {
      if (q.filters.articleLabel) {
        elements.push('articlelabel=' + q.filters.articleLabel);
      }
      if (q.filters.language && q.filters.language.length > 0) {
        elements.push('language=' + q.filters.language.join(','));
      }
      if (q.filters.publication && q.filters.publication.length > 0) {
        elements.push('publication=' + q.filters.publication.join(','));
      }
      if (q.filters.type && q.filters.type.length > 0) {
        elements.push('type=' + q.filters.type.join(','));
      }
      if (q.filters.tags && q.filters.tags.length > 0) {
        elements.push('tags=' + q.filters.tags.join(',,'));
      }
      if (q.filters.date) {
        elements.push('date=' + q.filters.date);
      }
    }
    if (elements.length > 0) {
      return '?' + elements.join('&');
    }
    return '';
  }

  static getApiQuery(q) {
    let apiQuery = Map();
    if (q.query) {
      apiQuery = apiQuery.set('query', q.query);
    }
    if (q.filters) {
      if (q.filters.tags && q.filters.tags.length > 0) {
        apiQuery = apiQuery.setIn(["filters", "tags"], List(q.filters.tags));
      }
      if (!q.filters.type || q.filters.type.length === 0) {
        if (q.filters.tags && q.filters.tags.length > 0) {
          apiQuery = apiQuery.setIn(["filters", "structure", "include"], false);
          apiQuery = apiQuery.setIn(["filters", "annotation", "include"], false);
        }
        else {
          apiQuery = apiQuery.setIn(["filters", "structure", "include"], true);
          apiQuery = apiQuery.setIn(["filters", "annotation", "include"], true);
        }
        apiQuery = apiQuery.setIn(["filters", "article", "include"], true);
      }
      else {
        apiQuery = apiQuery.setIn(["filters", "structure", "include"], false);
        apiQuery = apiQuery.setIn(["filters", "article", "include"], false);
        apiQuery = apiQuery.setIn(["filters", "annotation", "include"], false);
        if (q.filters.type.indexOf('structure') > -1) {
          apiQuery = apiQuery.setIn(["filters", "structure", "include"], true);
          apiQuery = apiQuery.setIn(["filters", "article", "include"], true);
          q.filters.type.splice(q.filters.type.indexOf('structure'), 1);
        }
        if (q.filters.type.length > 0) {
          apiQuery = apiQuery.setIn(["filters", "annotation", "include"], true);
          apiQuery = apiQuery.setIn(["filters", "annotation", "type"], List(q.filters.type));
        }
      }

      if (q.filters.articleLabel) {
        apiQuery = apiQuery.setIn(["filters", "article", "label"], q.filters.articleLabel);
        apiQuery = apiQuery.setIn(["filters", "annotation", "include"], false);
      }

      if (q.filters.publication) {
        apiQuery = apiQuery.setIn(["filters", "structure", "canonical"], List(q.filters.publication));
        if (!q.filters.type || q.filters.type.length === 0) {
          apiQuery = apiQuery.setIn(["filters", "structure", "include"], true);
          apiQuery = apiQuery.setIn(["filters", "article", "include"], true);
          apiQuery = apiQuery.setIn(["filters", "annotation", "include"], false);
        }
      }
      if (q.filters.language) {
        apiQuery = apiQuery.setIn(["filters", "language"], List(q.filters.language));
      }
      if (q.filters.date) {
        apiQuery = apiQuery.setIn(["filters", "date"], q.filters.date);
      }
    }

    return apiQuery.toJS();
  }
}



/** WEBPACK FOOTER **
 ** ./src/helpers/queryHelper.js
 **/